module.exports = __webpack_public_path__ + "static/img/roleTime@2x.cdfcf79e.png";